import { FormGroupName } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

import { FormGroup } from '@angular/forms';

import { FormPackage } from '../../models/df-package';

@Component({
	selector: 'df-select-box',
	templateUrl: './select-box.component.html',
	styleUrls: ['./select-box.component.scss']
})
export class SelectBoxComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() form: FormGroup;
	@Input() config: FormGroup;
	public options = [];
	constructor() {}

	ngOnInit(): void {
		this.options = this.package.options;
	}

	setConfigValue(key, value) {
		// console.log(key);
		// console.log(value);
		let obj = {};
		obj[key] = value;
		this.config.patchValue(obj);
	}
}
